import { CircularProgress, Grid } from '@mui/material';
import GridContainer from 'components/GridContainer';
import Heading from 'components/Heading';
import SnapshotBox from 'components/SnapshotBox/SnapshotBox';
import { numberToCurrencyString } from 'further-ui/utils';

type Totals = {
  totalAdvisers: number;
  investments: number;
  investors: number;
  totalCurrentValue: number;
  totalInitialInvestment: number;
  totalRealisedValue: number;
  totalUnrealisedValue: number;
  childOrganisationsCount: number;
};

type OrganisationSnapshotProps = {
  totals: Totals;
  isParent: boolean;
  isLoading: boolean;
};

export const OrganisationSnapshot = ({
  totals,
  isParent,
  isLoading,
}: OrganisationSnapshotProps) => {
  const {
    totalAdvisers = 0,
    investments = 0,
    investors = 0,
    totalInitialInvestment = 0,
    totalUnrealisedValue = 0,
    totalRealisedValue = 0,
    childOrganisationsCount = 0,
  } = totals || {};

  const averageInvestmentAmount =
    investments > 0 ? totalInitialInvestment / investments : 0;

  if (isLoading) {
    return (
      <GridContainer>
        <Grid
          size={{ xs: 12 }}
          style={{ textAlign: 'center', padding: '2rem' }}
        >
          <CircularProgress />
        </Grid>
      </GridContainer>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Heading variant="h2">Organisation snapshot</Heading>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox value={totalAdvisers} subtitle="Advisers" />
          </Grid>
          {isParent && (
            <Grid size={{ xs: 'grow' }}>
              <SnapshotBox
                value={childOrganisationsCount}
                subtitle="Organisations"
              />
            </Grid>
          )}
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox value={investors} subtitle="Investors" />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox value={investments} subtitle="Subscriptions" />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(totalInitialInvestment, {
                currency: 'GBP',
              })}
              subtitle="Total subscribed"
            />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(totalUnrealisedValue, {
                currency: 'GBP',
              })}
              subtitle="Unrealised value"
            />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(totalRealisedValue, {
                currency: 'GBP',
              })}
              subtitle="Realised value"
            />
          </Grid>
          <Grid size={{ xs: 'grow' }}>
            <SnapshotBox
              value={numberToCurrencyString(averageInvestmentAmount, {
                currency: 'GBP',
              })}
              subtitle="Average subscription"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganisationSnapshot;
